export default {
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    signingIn: 'Connexion en cours...',
    creatingAccount: 'Création du compte...',
    signInFailed: 'Échec de la connexion',
    signUpFailed: "Échec de l'inscription",
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    noAccount: "Vous n'avez pas de compte?",
    forgotPassword: 'Mot de passe oublié?',
    forgotPasswordTitle: 'Réinitialisez votre mot de passe',
    forgotPasswordDescription: 'Entrez votre courriel et nous vous enverrons un lien de réinitialisation.',
    sendResetLink: 'Envoyer le lien',
    sendingResetLink: 'Envoi...',
    checkYourEmail: 'Vérifiez votre courriel',
    resetLinkSent: 'Si ce courriel existe dans notre système, nous vous avons envoyé un lien de réinitialisation. Vérifiez votre boîte de réception.',
    resetPasswordTitle: 'Définir un nouveau mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    resettingPassword: 'Réinitialisation...',
    passwordResetSuccess: 'Votre mot de passe a été réinitialisé avec succès.',
    invalidResetLink: 'Ce lien de réinitialisation est invalide ou a expiré.',
    requestNewLink: 'Demander un nouveau lien',
    backToLogin: 'Retour à la connexion',
    form: {
        email: 'Courriel',
        password: 'Mot de passe',
        name: 'Nom',
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
    },
    validation: {
        emailInvalid: 'Veuillez entrer un courriel valide',
        passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
        nameMinLength: 'Le nom doit contenir au moins 2 caractères',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    },
};
